module.exports = __webpack_public_path__ + "static/img/dltt_gry.7d7a420.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dltt_gry.png
// module id = pkxK
// module chunks = 2